import script from "./courseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./courseDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__